import { Icon } from "@chakra-ui/react"

export const PlusIcon = (props: any) => (
  <Icon xmlns="http://www.w3.org/2000/svg" width="21.251" height="21.251" viewBox="0 0 21.251 21.251" {...props}>
    <g id="Group_45" data-name="Group 45" transform="translate(-2548.886 -1679.36)">
      <line id="Line_17" data-name="Line 17" y2="18.251" transform="translate(2559.512 1680.86)" fill="none" stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="3"/>
      <line id="Line_18" data-name="Line 18" x1="18.251" transform="translate(2550.386 1689.985)" fill="none" stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="3"/>
    </g>
  </Icon>
);
